import { render, staticRenderFns } from "./lp-live-market-purchase.vue?vue&type=template&id=1bbe0c30&scoped=true"
import script from "./lp-live-market-purchase.vue?vue&type=script&lang=js"
export * from "./lp-live-market-purchase.vue?vue&type=script&lang=js"
import style0 from "./lp-live-market-purchase.vue?vue&type=style&index=0&id=1bbe0c30&prod&scoped=true&lang=css"
import style1 from "./lp-live-market-purchase.vue?vue&type=style&index=1&id=1bbe0c30&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe0c30",
  null
  
)

export default component.exports